export const cssClass = {
  overlayProvider: 'OverlayProvider', // react-aria OverlayProvider, css/elements/elements.css
  darkTheme: 'darkTheme', // css/vars/theme-*.css
  lightTheme: 'lightTheme', // css/vars/theme-*.css
  showForLarge: 'showForLarge', // css/utils/utils.css
  disableChildPointerEvents: 'disableChildPointerEvents', // css/utils/utils.css
  reducedMotion: 'reducedMotion', // css/vars/motion.css
};
